export enum PageSize {
  A4 = "A4",
  A3 = "A3",
}

export enum PageOrientation {
  PORTRAIT = "portrait",
  LANDSCAPE = "landscape",
}
